import { TFunction } from 'i18next';

export const getCodeSelector = (t: TFunction) => [
  {
    key: 'calc',
    value: 'calc',
    text: t('documents:calcSpreadsheet'),
    extension: '.ods',
  },
  {
    key: 'draw',
    value: 'draw',
    text: t('documents:drawDrawing'),
    extension: '.odg',
  },
  {
    key: 'impress',
    value: 'impress',
    text: t('documents:impressPresentation'),
    extension: '.odp',
  },
  {
    key: 'writer',
    value: 'writer',
    text: t('documents:writerDocument'),
    extension: '.odt',
  },
];

export const perElemts = [
  {
    code: 'party',
    description: 'Party',
  },
  {
    code: 'property',
    description: 'Property',
  },
  {
    code: 'signer',
    description: 'Signer',
  },
];

export const emptyTemplate = {
  _id: '',
  code: '',
  name: '',
  per: [],
  data: {
    property: 'All',
    signer: [],
    party: [],
    deliver: [],
  },
  triggers: {
    transaction_type: 'All',
    type: 'All',
    workflow: 'All',
    projected_payments: 'All'
  },
};
